import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSavedDeliverySettings,
  fetchEstimatedDeliveryTargetCounts,
  updatedTargetSamples,
  logoutAdmin,
  logoutUser,
} from '~/api';
import * as qualificationsActions from '~/features/qualifications/qualificationsSlice';

/**
 * ages: [`${ageFrom}-${ageTo}`, ...],
 *
 * // このSliceのquotasはあくまで対象者検索結果のquotas。
 * // 過去データ取得APIのquotasとはフォーマットが異なる。
 * quotas: {
 *   `${ageFrom}-${ageTo}-${gender}`: {
 *     gender: number, // 1: 男性, 2: 女性, 3: 両方
 *     ageFrom: number,
 *     ageTo: number,
 *     minCollect: number,
 *   },
 *   ...
 * }
 *
 * targetSamples: {
 *   `${ageFrom}-${ageTo}-${gender}`: targetSamples,
 *   ...
 * }
 */
const initialState = {
  ages: [],
  quotas: {},
  targetSamples: {},
  collectCounts: {},
};

/**
 * 割付（配信対象者）データ管理用Slice。
 */
const quotasSlice = createSlice({
  name: 'quotas',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  extraReducers: {
    /**
     * 検索条件が変化したら検索結果テーブルを初期化する
     */
    [qualificationsActions.changed]: () => initialState,
    [qualificationsActions.changedSpecialPanelCheckedItems]: () => initialState,

    /**
     * 過去データの取得の場合は、過去データのtargetSamplesだけ欲しいので、quotasは初期値のままにしておく。
     * （このSliceのquotasはあくまで対象者検索結果のquotas。過去データ取得APIのquotasとはフォーマットが異なる）
     */
    [fetchSavedDeliverySettings.fulfilled.type]: (state, action) => {
      const { ages, targetSamples, collectCounts } = action.payload;
      return {
        ...state,
        ages,
        targetSamples,
        collectCounts,
        quotas: initialState.quotas,
      };
    },

    /**
     * 対象者検索ボタンがクリックされた時にトリガーされるAction後のstate更新。
     * targetSamplesはisReconstructingがtrueの時だけ0で初期化。
     */
    [fetchEstimatedDeliveryTargetCounts.fulfilled.type]: (state, action) => {
      const { ages, quotas, isReconstructing } = action.payload;
      const targetSamples = {};
      if (!isReconstructing) {
        Object.keys(quotas).forEach((key) => {
          targetSamples[key] = 0;
        });
        return {
          ...state,
          ages,
          quotas,
          targetSamples,
        };
      }
      return {
        ...state,
        ages,
        quotas,
      };
    },

    [updatedTargetSamples.fulfilled.type]: (state, action) => {
      return {
        ...state,
        targetSamples: action.payload.targetSamples,
      };
    },

    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

export const { initialize } = quotasSlice.actions;

// reducerをexportする
export default quotasSlice.reducer;
